import AppLoading, {AppLoadError} from '../../app_loading';
import React from "react";
import { Route, Link } from "react-router-dom";
import SettingsPromosItem from "./settings_promos_item";


export default class SettingsPromos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialLoading: true, loadError: false,
      promos: []
    }

    this.updatePromo = this.updatePromo.bind(this)
    this.createPromo = this.createPromo.bind(this)
    this.deletePromo = this.deletePromo.bind(this)
  }

  componentDidMount() { this.loadInitialSettings(); }

  componentWillUnmount() { this._settingsUnmounted = true; }

  loadInitialSettings = () => {
    this.setState({initialLoading: true, loadError: false});
    return Promise.all([this.props.fetchPromos(), this.props.fetchServicesSettings()]).then(values => {
      if (!this._settingsUnmounted) this.setState({promos: Object.values(values[0]), initialLoading: false});
    }).catch(() => {
      if (!this._settingsUnmounted) this.setState({initialLoading: false, loadError: true});
    });
  }

  updatePromo(promo) {
    this.props.openModal("updatePromo", { promo, onPromoUpdate: this.onPromoUpdate.bind(this) })
  }

  createPromo() {
    this.props.openModal("createPromo", { onPromoCreate: this.onPromoCreate.bind(this) })
  }

  onPromoUpdate(updatedPromo) {
    this.setState({ promos: this.state.promos.map(promo => promo.id === updatedPromo.id ? updatedPromo : promo) })
    this.props.showToast("Promo has been updated")
  }

  onPromoCreate(promo) {
    this.setState({ promos: [...this.state.promos, promo] })
    this.props.showToast("Promo has been created")
  }

  deletePromo(promo) {
    this.props.deletePromo(promo.id).then(() => {
      this.setState({ promos: this.state.promos?.filter(p => p.id !== promo.id) || [] })
      this.props.showToast("Promo has been removed")
    })
  }

  render() {
    if (this.state.initialLoading) return <AppLoading label="Loading promos…"/>;
    if (this.state.loadError) return <AppLoadError retry={this.loadInitialSettings}/>;
    let settingsPromosItems = this.state.promos.map((promo, i) => <SettingsPromosItem key={i} promo={promo} deletePromo={this.deletePromo} updatePromo={this.updatePromo} addInfo={this.props.addInfo} />)

    return (
      <div className="settingsPreferencesGroupingDiv">
        <div className="settingsPreferences settingsUsersList">
          <div className="settingsComponentHeading">Promotions</div>
          <div className="settingsPreferencesGroup1">
            <table className="w-100">
              <tbody>
                {settingsPromosItems}
              </tbody>
            </table>
          </div>
          <button onClick={this.createPromo} className="settingsButton preferencesButton">Create Promo</button>
        </div>
      </div>
    );
  }
}